import {
  TimeBasedMode,
  type TimeBasedCondition,
} from "@redotech/redo-flows-common/rules-v3/schemas";
import { RuleConditionType } from "@redotech/redo-flows-common/rules/types";
import { WeeklyScheduleSection } from "@redotech/redo-merchant-support-app/setting/rules/flow-editor/conditions/time-based-condition";
import type { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import type { WeeklyScheduleState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/weekly-schedule-chat";
import { memo, useCallback } from "react";

export const WeeklyScheduleChatDetails = memo(
  function WeeklyScheduleChatDetails({
    state,
    setState,
  }: ConditionTypeDetailsProps<WeeklyScheduleState>) {
    const adapted: Extract<TimeBasedCondition, { mode: "weekly_schedule" }> = {
      conditionType: RuleConditionType.TIME_BASED,
      mode: TimeBasedMode.WEEKLY_SCHEDULE,
      timezone: state.timezone,
      schedule: state.schedule,
    };

    const handleChange = useCallback(
      (updated: TimeBasedCondition) => {
        if (updated.mode === TimeBasedMode.WEEKLY_SCHEDULE) {
          setState({
            timezone: updated.timezone ?? state.timezone,
            schedule: updated.schedule ?? {},
          });
        }
      },
      [state.timezone, setState],
    );

    return (
      <WeeklyScheduleSection condition={adapted} onChange={handleChange} />
    );
  },
);
